// export { default as clientclublogo } from '../assets/images/logo/wellington.png';
// export { default as clientclublogow } from '../assets/images/logo/wellington-w.png';


// export { default as clientclublogo } from '../assets/images/mUc/muc logo copy.png';
// export { default as clientclublogow } from '../assets/images/mUc/muc logo white.png';

export { default as clientclublogo } from '../assets/images/logo/Belur.jpeg';
export { default as clientclublogow } from '../assets/images/logo/Belur.jpeg';
// export { default as clientclublogo } from '../assets/images/K_C_APP.svg';

export { default as mainGreenHomeIcon } from '../assets/images/home-button.png';

export const style = {
    width : 0,
    mainwidth : 35 //home icon
}